import { OnInit } from '@angular/core';
var HealthLoadingComponent = /** @class */ (function () {
    function HealthLoadingComponent() {
    }
    HealthLoadingComponent.prototype.ngOnInit = function () { };
    return HealthLoadingComponent;
}());
export { HealthLoadingComponent };
